import React, {useEffect} from 'react';
import MainApp from '@/modules/MainApp';
import {useAuth, useUser} from '@dofleini/security';
import UnauthenticatedApp from '@/modules/UnauthenticatedApp';
import {useTheme} from '@/contexts/ThemeContext';
import Favicon from 'react-favicon';

function App() {
  const {theme} = useTheme();
  const {logout} = useAuth();

  if (localStorage.getItem('storedSpace')) {
    localStorage.setItem('x-workspace', localStorage.getItem('storedSpace'));
  }

  const {user, hasPermission} = useUser();

  useEffect(() => {
    if (user && !hasPermission('ADMIN')){
      logout();
    }
  }, [hasPermission, logout, user]);

  return <>
    <Favicon url={theme?.general?.favicon}/>
    {
      (user && hasPermission('ADMIN')) ?
        <MainApp/> : <UnauthenticatedApp/>
    }
  </>;

}

export default App;
